import { Box, Stack, Typography } from "@mui/material";

import type { SSOProvider } from "@app/common/types/providerTypes";

interface AuthEmailProps {
  provider?: SSOProvider | null;
  email: string;
}

const AuthEmail = ({ email, provider }: AuthEmailProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ mb: "6px", maxWidth: "100%", width: "100%" }}
    >
      {provider && (
        <Box
          sx={{
            width: "32px",
            minWidth: "32px",
            height: "32px",
            minHeight: "32px",
            mr: 2,
          }}
        >
          <img
            style={{ width: "100%", display: "block" }}
            src={provider.icon}
            alt={`Sign up with ${provider.displayName}`}
          />
        </Box>
      )}
      <Typography
        variant="h3"
        sx={{
          fontSize: "1.75rem",
          fontWeight: 500,
          overflowWrap: "anywhere",
        }}
      >
        {email}
      </Typography>
    </Stack>
  );
};

export default AuthEmail;
